import { Component, OnInit, Input } from '@angular/core';
import { WaypointService } from 'src/app/services/core/waypoint.service';
import { VehicleService } from 'src/app/services/vehicle/vehicle.service';
import { MatDialog } from '@angular/material/dialog';
import { NavigationDisclaimerComponent } from '../../modals/navigation-disclaimer/navigation-disclaimer.component';
import { NavigationService } from 'src/app/services/core/navigation.service';
import { MapService } from 'src/app/services/map/map.service';
import { ConfirmationDialogComponent } from '../../modals/confirmation-dialog/confirmation-dialog.component';
import device from 'current-device';
import { LocationService } from 'src/app/services/platform/location.service';
import { WebviewService } from 'src/app/services/platform/webview.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { AccountService } from 'src/app/services/account/account.service';
import { ConsoleLoggerService } from 'src/app/services/logging/console-logger.service';
import { DisplayMode } from 'src/app/models/display-mode';
import { Position } from 'src/app/models/position';
import { LatLng } from 'src/app/models/latlng';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StackedModalsService } from 'src/app/services/modal/stacked-modals.service';

@Component({
  standalone: true,
  selector: 'app-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  imports: [CommonModule],
  styleUrls: ['./navigation-menu.component.scss']
})
export class NavigationMenuComponent implements OnInit {
  @Input() noRoute: boolean = false;
  @Input() failedPlan: boolean = false;
  @Input() loadingMap: boolean = false;
  public MobileApp: boolean = false;
  public replayMode: boolean = false;

  constructor(public matDialog: MatDialog, private readonly navigationService: NavigationService,
    private readonly waypointService: WaypointService, private readonly activatedRoute: ActivatedRoute,
    private readonly mapService: MapService, private readonly locationService: LocationService, public webviewService: WebviewService,
    public languageService: LanguageService, public settingsService: SettingsService, public accountService: AccountService,
    private readonly consoleLoggerService: ConsoleLoggerService, private readonly stackedModalsService: StackedModalsService,
    private readonly vehicleService: VehicleService) { }

  ngOnInit() {
    if (this.activatedRoute?.snapshot?.routeConfig?.path == "demo") {
      this.replayMode = true;
    }
    this.MobileApp = this.webviewService.IsGPSTWebview();
  }

  public startNavigation(): void {
    if (this.failedPlan || this.noRoute || this.loadingMap) return;

    if (!this.webviewService.IsGPSTWebview() && !globalThis.navigator.userAgent.includes("FB_IAB")) {
      if (document.body.classList.contains("demo")) {
        this.navigationService.ObservableChangeNavigation.next("start");
      }
      else {
        this.openNavigationDisclaimer(false);
      }
    }
    else if (device.android()) {
      this.webviewService.setBatteryOptimizationSettingsRequired(false);
      this.consoleLoggerService.log("getBatteryOptimizationActive", this.webviewService.getBatteryOptimizationActive());
      if (this.webviewService.getBatteryOptimizationActive()) {
        this.webviewService.setBatteryOptimizationSettingsRequired(true);
      }
      this.webviewService.StartNavigation();
      this.openNavigationDisclaimer(false);
    }
    else {
      this.webviewService.StartNavigation();
      this.openNavigationDisclaimer(true);
    }
  }

  // Shows the navigation disclaimer (unless a dialog is already open) and starts navigation once it is accepted.
  private openNavigationDisclaimer(moveReplayToStart: boolean): void {
    if (document.getElementsByClassName("mat-dialog-title").length != 0) return;
    const dialogRef = this.stackedModalsService.openModal(NavigationDisclaimerComponent, { data: {}, autoFocus: false });
    dialogRef.afterClosed().subscribe((resp) => {
      if (resp == "start") {
        // for demo mode change last location to current start point
        if (moveReplayToStart && this.replayMode) {
          this.locationService.setLastPosition(new Position({
            latitude: this.waypointService.getWaypointsParams()[0].lat,
            longitude: this.waypointService.getWaypointsParams()[0].lng,
            speed: 0, accuracy: 0, altitude: 0, altitudeAccuracy: 0, heading: 0, timestamp: 0
          }));
        }
        this.navigationService.ObservableChangeNavigation.next("start");
      }
    });
  }

  public backToRange(): void {
    const dialogRef = this.stackedModalsService.openModal(ConfirmationDialogComponent,
      {
        data: {
          title: this.languageService.languageJSON.NavigationMenu_ExitPlanning, message: this.languageService.languageJSON.NavigationMenu_ExitPlanning_Message,
          buttons: [this.languageService.languageJSON.Global_Exit, this.languageService.languageJSON.Global_Cancel]
        }, autoFocus: false
      });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.waypointService.setSelectedDisplayMode(DisplayMode.RANGE);
        const startcoord = this.waypointService.getWaypointsParams()[0];
        this.waypointService.setWaypointParams([startcoord]);
        this.vehicleService.setECarSettings(this.vehicleService.getECarSettings()!);
        this.mapService.ObservableMoveTo.next({ latlng: new LatLng(startcoord.lat, startcoord.lng), zoom: 12 });
      }
    });
  }
}
